import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import {default as userModule, defaultModuleName as userModuleName} from '@/modules/user/store'
import {default as orgModule, defaultModuleName as orgModuleName} from '@/modules/Organizations/store'
import {default as termModule, defaultModuleName as termModuleName} from '@/modules/Terminals/store'
import {default as navModule, defaultModuleName as navModuleName} from '@/modules/NavigationMenu/store'
import {default as cashvModule, defaultModuleName as cashModuleName} from '@/modules/Cashbox/store'
import {default as clientsModule, defaultModuleName as clientsModuleName} from '@/modules/Clients/store'
import {default as couponModule, defaultModuleName as couponModuleName} from '@/modules/Coupons/store'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    [userModuleName]: userModule,
    [orgModuleName]: orgModule,
    [navModuleName]: navModule,
    [termModuleName]: termModule,
    [cashModuleName]: cashvModule,
    [clientsModuleName]: clientsModule,
    [couponModuleName]: couponModule,

  },
  plugins: debug ? [createLogger()] : [],
})
